// getShapeFromLLM: expects your backend or direct OpenAI call to return JSON *string* in message.content
// Replace the fetch endpoint with your own if you have a proxy API.
export const API_BASE = "https://api.mutcloud.com";
export async function getShapeFromLLM(question) {
  try {
    const res = await fetch(`${API_BASE}/ai-tools/intent`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ question }),
    });
    if (!res.ok) throw new Error("LLM intent API error " + res.status);
    const data = await res.json();
    const content = data.content || data.message || data.shape || data;
    if (typeof content === "string") {
      try { return JSON.parse(content); } catch (e) { return null; }
    }
    return content;
  } catch (e) {
    console.warn("getShapeFromLLM failed:", e);
    return null;
  }
}

export async function getNarrativeFromLLM({ intent, shape, payload, mode = "single" }) {
  // payload = compact API data you’ll send (see next section)
  const res = await fetch(`${API_BASE}/ai-tools/summarize`, { // your backend proxy to OpenAI
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ intent, shape, payload, mode }),
  });
  if (!res.ok) throw new Error("LLM summarize error " + res.status);
  const data = await res.json();
  // Expect { text: "plain text summary" }
  return (data && data.text) || "";
}

